<template>
  <q-card flat bordered>
    <q-card-section
      class="q-pa-sm row bg-primary justify-between items-center text-white"
    >
      <div class="text-subtitle1 text-bold">
        <q-icon
          name="history_edu"
          style="font-size: 25px; padding-right: 0.1rem"
        />
        Payment History
      </div>

      <div class="row items-center q-gutter-x-sm">
        <slot name="header"></slot>
        <q-btn
          v-if="billingInfo && canChargeOrder"
          outline
          label="Charge Order"
          size="sm"
          class="float-right"
          style="top: 3px"
          :loading="charging"
          @click="handleOpenChargeOrderDialog"
        />
      </div>
    </q-card-section>

    <q-separator />
    <div class="q-pa-md" v-if="!loadingData && billingInfo">
      <p>
        <span>Current Card : {{billingInfo.creditCard.cardNumber}}</span>
        <span class="q-ml-sm">Total Charged: {{totalCharged | currency}}</span>
      </p>
      <q-table
        v-if="transactions.length > 0"
        flat
        :wrap-cells="true"
        :hide-pagination="true"
        style="height:300px"
        title="History"
        :data="transactionsRows"
        :columns="columnsConfig"
        row-key="name"
      />
    </div>
    <q-card-section v-if="loadingData">
      <q-skeleton type="rect" height="80px" animation="fade" />
    </q-card-section>
    <q-card-actions align="center" v-if="!loadingData && canAddPaymentManually">
      <q-btn
        v-if="billingInfo"
        dense
        flat
        color="primary"
        label="Update Payment Information"
        :loading="saving"
        @click="handleOpenBillingInfoDialog"
      ></q-btn>
      <q-btn
        v-else
        dense
        flat
        color="primary"
        label="Add Payment Information"
        :loading="saving"
        @click="handleOpenBillingInfoDialog"
      ></q-btn>
    </q-card-actions>
    <app-billing-information-dialog
      ref="billingInformationDialogRef"
      @on-save="$emit('on-change-billing-info', $event)"
    />
    <app-charge-order-dialog
      ref="chargeOrderDialogRef"
      @on-charge="$emit('on-charge-order', $event)"
    />
  </q-card>
</template>
<script>
import graphql from '@client/graphql';
import { assessPermission } from '@server/lib/permission-helpers';
import { formatString } from '@server/lib/date-format';
import AppBillingInformationDialog from '@client/components/dialogs/billing-information-dialog';
import AppChargeOrderDialog from '@client/components/dialogs/charge-order-dialog';

const columnsConfig = [
  {
    name: 'createdAt',
    field: 'createdAt',
    label: 'Date/Time',
    align: 'left'
  },
  {
    name: 'status',
    field: 'status',
    label: 'Status',
    align: 'left'
  },
  {
    name: 'amount',
    field: 'amount',
    label: 'Amount',
    align: 'left'
  },
  {
    name: 'note',
    field: 'note',
    label: 'Note',
    align: 'left',
    style: 'min-width:300px'
  }
];

export default {
  name: 'AppPaymentHistory',
  props: {
    loadingData: {
      type: Boolean,
      default: false
    },
    shipper: Object,
    origin: Object,
    destination: Object,
    transactions: {
      type: Array,
      default: function () {
        return [];
      }
    },
    billingInfo: Object,
    saving: Boolean,
    charging: Boolean
  },
  data() {
    return {
      columnsConfig
    };
  },
  apollo: {
    currentUser: {
      query: graphql.queries.currentUser
    }
  },
  components: {
    AppBillingInformationDialog,
    AppChargeOrderDialog
  },
  computed: {
    canAddPaymentManually() {
      return assessPermission.payment.canAddManually(this.currentUser);
    },
    canChargeOrder() {
      return assessPermission.payment.canCharge(this.currentUser);
    },
    transactionsRows() {
      return this.transactions.map((transaction) => {
        let note = '';

        if (!transaction.errorCode && transaction.transactionId) {
          note = `Manual payment: Crdit card on order.- ${transaction.order.id}\nCharge through Authorize.net - Transaction ID: ${transaction.transactionId}\nThis transaction has been approved. ${transaction.cardType} ${transaction.last4} Auth code: ${transaction.authCode}`;
        } else {
          note = `Manual payment: Crdit card on order.- ${transaction.order.id}\nCharge through Authorize.net - Transaction ID: \nError code: ${transaction.errorCode}`;
        }

        return {
          createdAt: formatString(transaction.createdAt),
          status: !transaction.errorCode && transaction.transactionId ? 'Added' : 'Declined',
          amount: transaction.amount ? this.$options.filters.currency(transaction.amount) : '',
          note
        };
      });
    },
    totalCharged() {
      return this.transactions.reduce((sum, transaction) => {
        if (!transaction.errorCode && transaction.transactionId) return sum + transaction.amount;
        return sum;
      }, 0);
    }
  },
  methods: {
    handleOpenBillingInfoDialog() {
      this.$refs.billingInformationDialogRef.openDialog({
        shipper: this.shipper,
        origin: this.origin,
        destination: this.destination
      });
    },
    handleOpenChargeOrderDialog() {
      this.$refs.chargeOrderDialogRef.openDialog();
    },
    closeBillingInformationDialog() {
      this.$refs.billingInformationDialogRef.closeDialog();
    }
  }
};
</script>
